import { Toast, Indicator } from "mint-ui";
import { SETLOGINTOKEN } from "../../systemFolder/SystemFuns";

export default class utils {
  static addCalendar(d, cycle) {
    let date = d ? new Date(d.replace(/-/g, "/")) : new Date();
    d = d - 1000 * 60 * 60 * cycle; //
    let yy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();
    let hh = date.getHours();
    let day = date.getDay();
    let mf =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let ss =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return {
      hh: hh,
      mf: mf,
      ss: ss,
      yy: yy,
      mm: mm,
      dd: dd,
      day: day
    };
  }

  /**
   * 判断字符串是否为空
   * @param str
   * @return {boolean}
   */
  static isNull(str) {
    return str == null || str.length === 0 || str === "";
  }
  /**
   * @desc 判断是否为身份证号
   * @param {String|Number}str
   * @return {Boolean}
   */
  static isIdCard(str) {
    return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(
      str
    );
  }
  /**
   * @desc 判断是否为手机号
   * @param {String|Number} str
   * @return {Boolean}
   */
  static isPhoneNum(str) {
    return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str);
  }
  /**
   * @desc 判断是否为手机号，错误手机号弹框
   * @param {String|Number} str
   * @return {Boolean}
   */
  static isPhoneNumToast(str) {
    if (str == "admin") {
      //admin 不做手机号校验
      return true;
    }
    if (!/^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str)) {
      Toast({
        message: "请输入合法的手机号码",
        iconClass: "icon icon-error"
      });
      return false;
    }
    return true;
  }
  /**
   * @desc
   * @param {String|Number} str
   * @return {Boolean}
   */
  static ToastError(str) {
    Toast({
      message: str,
      iconClass: "icon icon-error"
    });
  }
  /**
   * @desc
   * @param {String|Number} str
   * @return {Boolean}
   */
  static ToastSuccess(str,classname) {
    Toast({
      message: str,
      iconClass: "icon icon-success",
      duration: 1500,
      className:classname
    });
  }
  /**
   * @desc
   * @param {String|Number} obj
   * @return {Boolean}
   */
  static isNullToast(obj, str) {
    if (this.isNull(obj)) {
      Toast({
        message: str,
        iconClass: "icon icon-error"
      });
      return false;
    }
    return true;
  }


  //根据手机号码 获取密码
  static getPassword(phone) {
    var list = localStorage.getItem("userList")
      ? JSON.parse(localStorage.getItem("userList"))
      : [];
    for (var i in list) {
      if (list[i].phone == phone) {
        return list[i].password;
      }
    }
    return "";
  }
  static notNullData(date) {
    for (var i in date) {
      if (this.isNull(date[i].val)) {
        Toast({
          message: date[i].message,
          iconClass: "icon icon-error"
        });
        return true;
      }
    }
    return false;
  }
  static openLoading(title) {
    Indicator.open({
      text: title + "...",
      //文字
      spinnerType: "fading-circle"
      //样式
    });
  }
  static closeLoading() {
    Indicator.close();
  }
  //里面拿不到this 传入当前this
  //isGoBack 不传则需要华为返回 或者传入fasle  传入true 则不需要
  /*
      date:{
        path:'',
        query:'',//
      }
    */
  static $routPush(_this, date, isGoBack) {
    if (!isGoBack) {
      sessionStorage.setItem("stopRouter", "Y");
    }
    _this.$router.push(date);
  }
  /*
    将对象里面的 error 转为0
    */
  static dataErrorRemove(date) {
    let errorData = {
      medicineName: "药方名称",
      count: "服用次数",
      dose: "剂量",
      unit: "剂量单位"
    };
    let count = 0;
    let str = "";
    for (var i in date) {
      if (date[i] == "error" || date[i] == "Error") {
        date[i] = "";
        str += errorData[i] + ",";
        count++;
      }
    }
    if (count >= 2) {
      Toast({
        message: str + "识别失败",
        iconClass: "icon icon-error"
      });
      return false;
    }
    return true;
  }

  static goJumpNucleicAcids() {
    let data = {
      webAction: "jumpNucleicAcids"
    };
    if (window.jumpNucleicAcids && window.jumpNucleicAcids.call) {
      //
      //this.doTnucleicAcid("核酸",_this)
      const result = window.jumpNucleicAcids.call(JSON.stringify(data)); //核酸检测
    }
  }
  static jumpNucleicAcids(_this) {
    let data = {
      webAction: "getVersion"
    };
    if (window.getVersion && window.getVersion.call) {
      //
      const result = window.getVersion.call(JSON.stringify(data)); //核酸检测
      if (result == "2.1.6") {
        this.goJumpNucleicAcids();
      }
    } else {
      this.goJumpNucleicAcids();
    }
    this.doTnucleicAcid("核酸", _this);
  }
  static isAccountSource(_this, str, flag) {
    if (!flag) {
      _this.utils.ToastSuccess(str); //"游客暂不支持发帖，请注册登录！"
      return true;
    }
    return false;
  }
  static isMobileNumber(e) {
    let i =
        "134,135,136,137,138,139,150,151,152,157,158,159,187,188,147,182,183,184,178",
      n = "130,131,132,155,156,185,186,145,176",
      a = "133,153,180,181,189,177,173,170",
      o = e || "",
      r = o.substring(0, 3),
      d = o.substring(0, 4),
      s =
        !!/^1\d{10}$/.test(o) &&
        (n.indexOf(r) >= 0
          ? "联通"
          : a.indexOf(r) >= 0
          ? "电信"
          : "1349" == d
          ? "电信"
          : i.indexOf(r) >= 0
          ? "移动"
          : "未知");
    return s;
  }

  static doTnucleicAcid(name, _this) {
    let token = localStorage.getItem("token");
    _this
      .$post(`/remind/recordUser?token=${token}&cardType=${name}`, {})
      .then(response => {})
      .catch(e => {
        console.log(e);
      });
  }

  static addRecord(recordName, _this) {
    // let token = localStorage.getItem("token");
    _this
      .$post(`/user/addRecord`, { recordType: 3, recordName: recordName })
      .then(response => {
        // console.log('addRecord'+JSON.stringify(response));
      })
      .catch(e => {
        console.log(e);
      });
  }

  static visitorLogin(_this) {
    if (sessionStorage.getItem("visitorLogin") == "Y") {
      return false;
    }
    sessionStorage.setItem("visitorLogin", "Y");
    let userData = {
      password: "",
      phone: "",
      accountSource: 3
    };
    _this.$post("/user/login", userData).then(response => {
        let model = localStorage.getItem('phoneModel')
        sessionStorage.removeItem("noLogin"); //删除
        if (response.data.code == "200") {
          //当前登录的用户信息
          localStorage.setItem("token", response.headers.token);
          localStorage.removeItem("accountNumberId");
          sessionStorage.removeItem("visitorLogin");
          //游客token存储
          SETLOGINTOKEN({
            webAction: "loginToken",
            loginToken:response.headers.token
          })
          // if(localStorage.getItem("noLoginId")==null){
          _this.getCurrentUserT();
          // }
          // localStorage.setItem("phone",response.data.data.phone)
          // let userName = response.data.data.userName || this.userData.userName
          localStorage.setItem("userName", response.data.data.userName);
          // if(model == 'HOM'){
          //   if (window.loginToken && window.loginToken.call) {
          //     //登录成功以后调用鸿蒙
          //     const result = window.loginToken.call(
          //       '{"webAction":"loginToken","loginToken":"' +
          //         response.headers.token +
          //         '"}'
          //     );
          //     console.log(result);
          //   }
          // }else if(model == 'Android'){
          // };
          _this.utils.$routPush(_this, {
            path: "/remindMeds",
            query: {
              tourist: "tourist"
            }
          });
          _this.utils.jumpNucleicAcids(_this);
        } else {
          _this.utils.ToastError(response.data.msg);
        }
      })
      .catch(e => {
        console.log(e);
      });
  }

  static setStatusBarColor(color) {
    let data = {
      webAction: "setStatusBarColor",
      color: color
    };
    if (window.setStatusBarColor && window.setStatusBarColor.call) {
      const result = window.setStatusBarColor.call(JSON.stringify(data)); //问题反馈
    }
  }
  /**
   * 记录日活
   */
  static async recordActivityCount(this_,model) {
    let { data } = await this_.$get("/remind/getCurrentUserT");
    if (!data) return;
    let { accountSource } = data;
    let data_ = accountSource == 3
        ? {
            recordType: 1,
            recordName: "游客日活",
            model:localStorage.getItem('userAgent') || model
          }
        : {
            recordType: 2,
            recordName: "用户日活",
            model:localStorage.getItem('userAgent') || model
          };
    this_.$post("/remind/recordActiveUser", data_);
  }
  // 图片转化
  static base64ToBlob(base64) {
    var arr = base64.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  /*  时间处理 -------------------------------------------*/
    static getDate(params) {
      var dt = new Date(this.getSpecificDate().replace(/-/g, "/"));
      dt.setMonth(dt.getMonth() - Number(params));
      return this.getSpecificDate(dt); //这里只是把 "/" 替换为 "-" ;  看需要可去掉;
    }
    // 获取当前时间 年月日时分秒
    static getNowTime(val) {
      let dateTime;
      if(typeof val == 'string'){
        val = val.replace(/-/g, "/")
      }
      let date = val ? new Date(val) : new Date();
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      let hh = date.getHours();
      let mf = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      return dateTime;
    }

    // 获取当前时间 年月日时分秒
    static getNowTime1(val) {
      let dateTime;
      let date = val ? new Date(val.replace(/-/g, "/")) : new Date();
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      let hh = date.getHours();
      let mf =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf;
      return dateTime;
    }
    // 获取当前时间 年月日时分秒
    static getNextDay(d, cycle) {
      d = new Date(d.replace(/-/g, "/"));
      d = +d + 1000 * 60 * 60 * cycle;
      //let date = this.getNowTime(d)
      return this.getNowTime(d);
    }

    // 获取当前时间 年月日时分秒
    static getSpecificDate(val,type) {
      if (typeof val == "string") {
        val = val.replace(/-/g, "/");
      }
      let date = val ? new Date(val) : new Date();
      let dateTime;
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1>=10?date.getMonth() + 1:'0'+(date.getMonth() + 1);
      let dd = date.getDate()>=10?date.getDate():'0'+date.getDate();
      let HH = date.getHours();
      let MM = date.getMinutes()>=10? date.getMinutes(): '0'+ date.getMinutes();
      if(type){
        dateTime = yy + "-" + mm + "-" + dd +" "+ HH +":"+ MM;
      }else {
        dateTime = yy + "-" + mm + "-" + dd;
      }
      return dateTime;
    }
    /**
     *
     * @param {*} _data 如果没有传时间取当前时间
     * @returns
     */
    static getTimeState(_data) {
      // 获取当前时间
      let timeNow = _data ? new Date(_data.replace(/-/g, "/")) : new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let text = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 10) {
        text = `早上`;
      } else if (hours > 10 && hours <= 14) {
        text = `中午`;
      } else if (hours > 14 && hours <= 18) {
        text = `下午`;
      } else if (hours > 18 && hours <= 24) {
        text = `晚上`;
      }
      let mf =
        timeNow.getHours() < 10 ? "0" + timeNow.getHours() : timeNow.getHours();
      let ss =
        timeNow.getMinutes() < 10
          ? "0" + timeNow.getMinutes()
          : timeNow.getMinutes();
      // 返回当前时间段对应的状态
      return text + ` ${mf}:${ss}`;
    }
    static getMonthAndDay(val) {
      let date = val ? new Date(val.replace(/-/g, "/")) : new Date();
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      mm = mm + 1 < 10 ? "0" + mm : mm;
      let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return {
        mm_dd: `${mm}${dd}`,
        yy_mm_dd: `${yy}-${mm}-${dd}`
      };
    }
    static timeDifferDay(time, time1) {
      var dateBegin = new Date(time.replace(/-/g, "/")); //初始时间
      var date = new Date(time1.replace(/-/g, "/")); //未来时间
      var result = date.getTime() - dateBegin.getTime();
      var joinTime = Math.ceil(result / (24 * 3600 * 1000));
      return joinTime || 1;
    }

    // 获取当前时间 月日时分
    static getChinaNowTime(val) {
      let dateTime;
      let date = val ? new Date(val.replace(/-/g, "/")) : new Date();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      let hh = date.getHours();

      dateTime = mm + "月" + dd + "日 " + hh + "点";
      return dateTime;
    }
    static getarrrandvalue(arr) {
      if (arr.length < 1) {
        return "";
      }
      var index = Math.floor(Math.random() * arr.length);
      return arr[index];
    }
    static getRemindNowTime(time,type) {//remindMeds
      let dateTime;
      if (typeof time == "string") {
        time = time.replace(/-/g, "/");
      }
      let date = time ? new Date(time) : new Date();
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      if(type=='dot'){
        dateTime = yy + "/" + mm + "/" + dd
      }else{
        dateTime = yy + "年" + mm + "月" + dd + "日";
      }
      return dateTime;
    }

    static getRemindNowTime2(time) {
      let dateTime;
      let date;
      if (time) {
        date = new Date(time);
      } else {
        date = new Date();
      }

      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      if (mm < 10) {
        mm = "0" + mm;
      }
      let dd = date.getDate();
      if (dd < 10) {
        dd = "0" + dd;
      }

      dateTime = yy + "-" + mm + "-" + dd;
      return dateTime;
    }
    //获取时分
    static getDateTime() {
      let date = new Date();
      let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let mf =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return hh + "" + mf;
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/utils.js